import React from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { Bar } from 'react-chartjs-2';

export function ProtocolsPerServiceChannel({ data }) {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        data: data.data,
        backgroundColor: data.backgroundColor
      }
    ]
  };

  const options = {
    indexAxis: 'y',
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          stepSize: 5
        }
      }
    },
    responsive: true,
    maintainAspectRatio: true
  };

  return (
    <Card>
      <CardHeader>
        <h5 className="h3 mb-0">Protocolos por Canal de Serviço</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col style={{ alignSelf: 'center', width: '100%' }}>
            <div
              className="chart"
              style={{ maxHeight: '400px', overflowY: 'auto', width: '100%' }}
            >
              <Bar data={chartData} options={options} />
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
